<template>
    <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_18642_23408)">
            <path
                d="M4.90584 2.85714C4.90584 2.09938 5.21598 1.37266 5.76804 0.836838C6.32009 0.30102 7.06884 0 7.84956 0C8.63029 0 9.37904 0.30102 9.93109 0.836838C10.4831 1.37266 10.7933 2.09938 10.7933 2.85714V7.61905C10.7933 8.37681 10.4831 9.10354 9.93109 9.63935C9.37904 10.1752 8.63029 10.4762 7.84956 10.4762C7.06884 10.4762 6.32009 10.1752 5.76804 9.63935C5.21598 9.10354 4.90584 8.37681 4.90584 7.61905V2.85714Z"
                :fill="color" />
            <path
                d="M3.43398 6.19048C3.5641 6.19048 3.68889 6.24065 3.7809 6.32995C3.87291 6.41925 3.9246 6.54037 3.9246 6.66667V7.61905C3.9246 8.6294 4.33812 9.59836 5.0742 10.3128C5.81027 11.0272 6.8086 11.4286 7.84956 11.4286C8.89053 11.4286 9.88886 11.0272 10.6249 10.3128C11.361 9.59836 11.7745 8.6294 11.7745 7.61905V6.66667C11.7745 6.54037 11.8262 6.41925 11.9182 6.32995C12.0102 6.24065 12.135 6.19048 12.2651 6.19048C12.3953 6.19048 12.5201 6.24065 12.6121 6.32995C12.7041 6.41925 12.7558 6.54037 12.7558 6.66667V7.61905C12.7558 8.79955 12.304 9.93798 11.4881 10.8135C10.6722 11.689 9.55036 12.2391 8.34018 12.3571V14.2857H11.2839C11.414 14.2857 11.5388 14.3359 11.6308 14.4252C11.7228 14.5145 11.7745 14.6356 11.7745 14.7619C11.7745 14.8882 11.7228 15.0093 11.6308 15.0986C11.5388 15.1879 11.414 15.2381 11.2839 15.2381H4.41522C4.2851 15.2381 4.16031 15.1879 4.0683 15.0986C3.97629 15.0093 3.9246 14.8882 3.9246 14.7619C3.9246 14.6356 3.97629 14.5145 4.0683 14.4252C4.16031 14.3359 4.2851 14.2857 4.41522 14.2857H7.35894V12.3571C6.14876 12.2391 5.0269 11.689 4.211 10.8135C3.39511 9.93798 2.94334 8.79955 2.94336 7.61905V6.66667C2.94336 6.54037 2.99505 6.41925 3.08706 6.32995C3.17907 6.24065 3.30386 6.19048 3.43398 6.19048Z"
                :fill="color" />
        </g>
        <defs>
            <clipPath id="clip0_18642_23408">
                <rect width="15.6999" height="15.2381" :fill="color" />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: 'white'
        },
        size: {
            type: String,
            default: "16"
        }
    }
}
</script>